module.exports = __webpack_public_path__ + "6cd03646206c8d0ac6f7011851425a7d.png";